import { render, staticRenderFns } from "./DiscountsRow.vue?vue&type=template&id=3b063f88&scoped=true&"
import script from "./DiscountsRow.vue?vue&type=script&lang=js&"
export * from "./DiscountsRow.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsRow.vue?vue&type=style&index=0&id=3b063f88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b063f88",
  null
  
)

export default component.exports